module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("upgrade_form_oneclick_error", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Upgrade error"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["textNode",{"text":" Can't upgrade already upgraded user. Please try to reload page. "}]]],["div",{"class":"popup-footer-wrapper"},[["button",{"class":"mc-common-button simple close"},[["textNode",{"text":"Close"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/popup/joinFormError.tpl
// module id = 742
// module chunks = 4